/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  faCalendar,
  faUser,
  faUsers,
  faUserSlash,
  faUsersSlash,
  faRepeat
} from '@fortawesome/pro-regular-svg-icons';
import { Subject } from 'rxjs';
import { TaskAssignmentType } from '../../../../enums/task-assignment-type.enum';
import {
  CustomDateFormatService,
  DateFormat
} from '../../../../services/custom-date-format/custom-date-format.service';
import { EmployeeService } from '../../../../services/employee.service';
import { RecurringConfig, ScheduledTaskService } from '../../../../services/scheduled-task.service';
import { RecurringModel } from '../../../../models/scheduled-task.model';

@Component({
  selector: 'app-scheduled-task',
  templateUrl: './scheduled-task.component.html',
  styleUrls: ['./scheduled-task.component.scss'],
  standalone: false
})
export class ScheduledTaskComponent implements OnInit, OnDestroy {
  faCalendar = faCalendar;
  faRepeat = faRepeat;
  faUser = faUser;
  faUsers = faUsers;
  faUserSlash = faUserSlash;
  faUsersSlash = faUsersSlash;
  DateFormat = DateFormat;

  TaskAssignmentType = TaskAssignmentType;

  scheduledTasks$ = this.scheduledTaskService.filteredScheduledTasks$;
  componentDestroyed$ = new Subject<boolean>();
  taskManagerRouterLink = '../activities/task-manager';

  constructor(
    private scheduledTaskService: ScheduledTaskService,
    private employeeService: EmployeeService,
    public customDateFormatService: CustomDateFormatService
  ) {}

  ngOnInit(): void {
    this.employeeService.getEmployees();
    this.employeeService.getEmployeeGroups();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  employeeExists(id: string): boolean {
    return this.employeeService.getEmployeeUserNameFromID(id) !== undefined;
  }

  employeeGroupsExist(groupIds: string[]): number {
    let existCount = 0;

    groupIds.forEach((id) => {
      if (this.employeeService.getEmployeeGroupNameFromID(id) !== undefined) {
        existCount++;
      }
    });

    return existCount;
  }

  getRecurringConfigFromService(
    scheduledTaskRecurring: RecurringModel,
    scheduledAt: string
  ): string {
    return this.scheduledTaskService.getRecurringConfig(
      scheduledTaskRecurring,
      RecurringConfig.withRepeat,
      scheduledAt
    );
  }
}
